import React from 'react'
import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid'

export const ColumnMenu: React.FC<GridColumnMenuProps> = (props: GridColumnMenuProps) => {
  return (
    <div>
      <GridColumnMenuFilter {...props} filterable={false} expanded />
    </div>
  )
}
